import axiosInstance from './axios-instance';

export default function axiosErrorInterceptor(store, router) {
  axiosInstance.interceptors.response.use(undefined, (err) => new Promise((resolve, reject) => {
    // eslint-disable-next-line no-underscore-dangle
    if (err.config && !err.config.__isRetryRequest && err.response.status === 401) {
      // when auth token is expired refresh it
      if (err.response.data.error.code === 3) {
        store.dispatch('auth/refreshToken')
          .then(async () => {
          // rewrite the current Authorization header
            axiosInstance.defaults.headers.Authorization = `Bearer ${store.state.auth.token}`;
            // eslint-disable-next-line no-param-reassign
            err.config.headers.Authorization = axiosInstance.defaults.headers.Authorization;

            return axiosInstance(err.config)
              .then((response) => resolve(response))
              .catch((response) => reject(response));
          })
          .catch((error) => reject(error));
      } else {
        store.dispatch('auth/logout');
        router.push({ path: '/login' });
      }
    }
    reject(err);
  }));
}
